// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getCategoriesTravel as listCategoriesTravelAPI,
    getCategoryTravel as getCategoryTravelAPI,
    addCategoryTravel as addCategoryTravelAPI,
    updateCategoryTravel as updateCategoryTravelAPI,
    deleteCategoryTravel as deleteCategoryTravelAPI,
} from '../../helpers/';

import { categoriesTravelApiResponseError, categoriesTravelApiResponseSuccess } from './actions';
import { CategoriesTravelActionTypes } from './constants';


/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getCategoryTravel({ payload: { id } }) {
    try {
        const response = yield call(getCategoryTravelAPI, id );
        const categoriaItem = response.data.data;
        yield put(categoriesTravelApiResponseSuccess(CategoriesTravelActionTypes.GET_CATEGORY_TRAVEL, categoriaItem));
    } catch (error) {
        yield put(categoriesTravelApiResponseError(CategoriesTravelActionTypes.GET_CATEGORY_TRAVEL, error));
    }
}

function* addCategoryTravel({payload:categoria}){
    try{
        const response = yield call(addCategoryTravelAPI,{...categoria})
        const categoriaItem = response.data
        yield put(categoriesTravelApiResponseSuccess(CategoriesTravelActionTypes.ADD_CATEGORY_TRAVEL,categoriaItem))
    } catch(error){
        yield put(categoriesTravelApiResponseError(CategoriesTravelActionTypes.ADD_CATEGORY_TRAVEL,error))
    }
}

function* updateCategoryTravel({payload:categoria}){
    try{
        const response = yield call(updateCategoryTravelAPI,{...categoria})
        const categoriaItem = response.data.data
        yield put(categoriesTravelApiResponseSuccess(CategoriesTravelActionTypes.UPDATE_CATEGORY_TRAVEL,categoriaItem))
    }catch(error){
        yield put(categoriesTravelApiResponseError(CategoriesTravelActionTypes.UPDATE_CATEGORY_TRAVEL,error))
    }
}
function* deleteCategoryTravel({payload:{id}}){
    try{
        const response = yield call(deleteCategoryTravelAPI,id)
        const categoriaItem = response.data.id
        yield put(categoriesTravelApiResponseSuccess(CategoriesTravelActionTypes.DELETE_CATEGORY_TRAVEL,categoriaItem))
    }catch(error){
        yield put(categoriesTravelApiResponseError(CategoriesTravelActionTypes.DELETE_CATEGORY_TRAVEL,error))
    }
}

/**
 * List contactos
 */
function* listCategoriesTravel({payload:params}) {
    try {
        const response = yield call(listCategoriesTravelAPI, { ...params });
        const listaCategorias = response.data.data;
        yield put(categoriesTravelApiResponseSuccess(CategoriesTravelActionTypes.LIST_CATEGORIES_TRAVEL, listaCategorias));
    } catch (error) {
        yield put(categoriesTravelApiResponseError(CategoriesTravelActionTypes.LIST_CATEGORIES_TRAVEL, error));
    }
}


export function* watchGetCategoryTravel(): any {
    yield takeEvery(CategoriesTravelActionTypes.GET_CATEGORY_TRAVEL, getCategoryTravel);
}

export function* watchListCategoriesTravel(): any {
    yield takeEvery(CategoriesTravelActionTypes.LIST_CATEGORIES_TRAVEL, listCategoriesTravel);
}

export function* watchAddCategoryTravel():any{
    yield takeEvery(CategoriesTravelActionTypes.ADD_CATEGORY_TRAVEL,addCategoryTravel)
}
export function* watchUpdateCategoryTravel():any{
    yield takeEvery(CategoriesTravelActionTypes.UPDATE_CATEGORY_TRAVEL,updateCategoryTravel)
}
export function* watchDeleteCategoryTravel():any{
    yield takeEvery(CategoriesTravelActionTypes.DELETE_CATEGORY_TRAVEL,deleteCategoryTravel)
}


function* categoriesTravelSaga(): any {
    yield all([
        fork(watchGetCategoryTravel),
        fork(watchListCategoriesTravel),
        fork(watchAddCategoryTravel),
        fork(watchUpdateCategoryTravel),
        fork(watchDeleteCategoryTravel),
    ]);
}

export default categoriesTravelSaga;
